module.exports = __webpack_public_path__ + "img/logo_white.svg?version=79863cf9";